export { default } from "./src/animation-wrapper";

export type { UniformAnimationWrapperProps } from "./src/animation-wrapper";
